/** THIS FILE IS PARTIALLY GENERATED, DO NOT REMOVE ANY MARKING! */
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

/** START: TRANSLATION IMPORT */
import enTranslation from './locales/en/linguise.json';
import arTranslation from './locales/ar/linguise.json';
import csTranslation from './locales/cs/linguise.json';
import daTranslation from './locales/da/linguise.json';
import deTranslation from './locales/de/linguise.json';
import elTranslation from './locales/el/linguise.json';
import esTranslation from './locales/es/linguise.json';
import fiTranslation from './locales/fi/linguise.json';
import frTranslation from './locales/fr/linguise.json';
import hiTranslation from './locales/hi/linguise.json';
import hrTranslation from './locales/hr/linguise.json';
import huTranslation from './locales/hu/linguise.json';
import idTranslation from './locales/id/linguise.json';
import itTranslation from './locales/it/linguise.json';
import jaTranslation from './locales/ja/linguise.json';
import koTranslation from './locales/ko/linguise.json';
import nlTranslation from './locales/nl/linguise.json';
import noTranslation from './locales/no/linguise.json';
import plTranslation from './locales/pl/linguise.json';
import ptTranslation from './locales/pt/linguise.json';
import roTranslation from './locales/ro/linguise.json';
import ruTranslation from './locales/ru/linguise.json';
import svTranslation from './locales/sv/linguise.json';
import thTranslation from './locales/th/linguise.json';
import trTranslation from './locales/tr/linguise.json';
import ukTranslation from './locales/uk/linguise.json';
import viTranslation from './locales/vi/linguise.json';
import zhcnTranslation from './locales/zh-cn/linguise.json';
/** END: TRANSLATION IMPORT */

/** START: FLAG IMPORT */
import enFlag from './assets/images/langs/en.svg';
import arFlag from './assets/images/langs/ar.svg';
import csFlag from './assets/images/langs/cs.svg';
import daFlag from './assets/images/langs/da.svg';
import deFlag from './assets/images/langs/de.svg';
import elFlag from './assets/images/langs/el.svg';
import esFlag from './assets/images/langs/es.svg';
import fiFlag from './assets/images/langs/fi.svg';
import frFlag from './assets/images/langs/fr.svg';
import hiFlag from './assets/images/langs/hi.svg';
import hrFlag from './assets/images/langs/hr.svg';
import huFlag from './assets/images/langs/hu.svg';
import idFlag from './assets/images/langs/id.svg';
import itFlag from './assets/images/langs/it.svg';
import jaFlag from './assets/images/langs/ja.svg';
import koFlag from './assets/images/langs/ko.svg';
import nlFlag from './assets/images/langs/nl.svg';
import noFlag from './assets/images/langs/no.svg';
import plFlag from './assets/images/langs/pl.svg';
import ptFlag from './assets/images/langs/pt.svg';
import roFlag from './assets/images/langs/ro.svg';
import ruFlag from './assets/images/langs/ru.svg';
import svFlag from './assets/images/langs/sv.svg';
import thFlag from './assets/images/langs/th.svg';
import trFlag from './assets/images/langs/tr.svg';
import ukFlag from './assets/images/langs/uk.svg';
import viFlag from './assets/images/langs/vi.svg';
import zhcnFlag from './assets/images/langs/zh-cn.svg';
/** END: FLAG IMPORT */

import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        ns: 'linguise',
        defaultNS: 'linguise',
        fallbackLng: 'en',
        debug: import.meta.env.VITE_BUILD_MODE === 'development',
        useSuspense: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            // format: (value, format, lng) => {
            //     if (format === 'formatTTL') {
            //         const seconds = Number(value);
            //         const minute = 60;
            //         const hour = minute * 60;
            //         const day = hour * 24;
            //         if (seconds % day === 0) {
            //             const days = seconds / day;
            //             return i18n.getFixedT(lng)('plans.period.days', {count: days});
            //         } else if (seconds % hour === 0) {
            //             const hours = seconds / hour;
            //             return i18n.getFixedT(lng)('plans.period.hours', {count: hours});
            //         } else if (seconds % minute === 0) {
            //             const minutes = seconds / minute;
            //             return i18n.getFixedT(lng)('plans.period.minutes', {count: minutes});
            //         }
            //         return i18n.getFixedT(lng)('plans.period.seconds', {count: seconds});;
            //     }
            //     return value;
            // }
        },
        pluralSeparator: '@@',
        simplifyPluralSuffix: true,
        // compatibilityJSON: 'v3',
        resources: {
            /** START: RESOURCES IMPORT */
            'en': {linguise: enTranslation},
            'ar': {linguise: arTranslation},
            'cs': {linguise: csTranslation},
            'da': {linguise: daTranslation},
            'de': {linguise: deTranslation},
            'el': {linguise: elTranslation},
            'es': {linguise: esTranslation},
            'fi': {linguise: fiTranslation},
            'fr': {linguise: frTranslation},
            'hi': {linguise: hiTranslation},
            'hr': {linguise: hrTranslation},
            'hu': {linguise: huTranslation},
            'id': {linguise: idTranslation},
            'it': {linguise: itTranslation},
            'ja': {linguise: jaTranslation},
            'ko': {linguise: koTranslation},
            'nl': {linguise: nlTranslation},
            'no': {linguise: noTranslation},
            'pl': {linguise: plTranslation},
            'pt': {linguise: ptTranslation},
            'ro': {linguise: roTranslation},
            'ru': {linguise: ruTranslation},
            'sv': {linguise: svTranslation},
            'th': {linguise: thTranslation},
            'tr': {linguise: trTranslation},
            'uk': {linguise: ukTranslation},
            'vi': {linguise: viTranslation},
            'zh-CN': {linguise: zhcnTranslation},
            /** END: RESOURCES IMPORT */
        },
        detection: {
            lookupCookie: 'lang'
        },
    });

/** START: LANGUAGES MAPPINGS */
export const languagesMapping = [
    {code: 'en', name: 'English', flag: enFlag, isRtl: false},
    {code: 'ar', name: 'العربية', flag: arFlag, isRtl: true},
    {code: 'cs', name: 'Čeština', flag: csFlag, isRtl: false},
    {code: 'da', name: 'Dansk', flag: daFlag, isRtl: false},
    {code: 'de', name: 'Deutsch', flag: deFlag, isRtl: false},
    {code: 'el', name: 'Ελληνικά', flag: elFlag, isRtl: false},
    {code: 'es', name: 'Español', flag: esFlag, isRtl: false},
    {code: 'fi', name: 'Suomi', flag: fiFlag, isRtl: false},
    {code: 'fr', name: 'Français', flag: frFlag, isRtl: false},
    {code: 'hi', name: 'हिन्दी', flag: hiFlag, isRtl: false},
    {code: 'hr', name: 'Hrvatski', flag: hrFlag, isRtl: false},
    {code: 'hu', name: 'Magyar', flag: huFlag, isRtl: false},
    {code: 'id', name: 'Indonesia', flag: idFlag, isRtl: false},
    {code: 'it', name: 'Italiano', flag: itFlag, isRtl: false},
    {code: 'ja', name: '日本語', flag: jaFlag, isRtl: false},
    {code: 'ko', name: '한국어', flag: koFlag, isRtl: false},
    {code: 'nl', name: 'Nederlands', flag: nlFlag, isRtl: false},
    {code: 'no', name: 'Norsk', flag: noFlag, isRtl: false},
    {code: 'pl', name: 'Polski', flag: plFlag, isRtl: false},
    {code: 'pt', name: 'Português', flag: ptFlag, isRtl: false},
    {code: 'ro', name: 'Română', flag: roFlag, isRtl: false},
    {code: 'ru', name: 'Русский', flag: ruFlag, isRtl: false},
    {code: 'sv', name: 'Svenska', flag: svFlag, isRtl: false},
    {code: 'th', name: 'ไทย', flag: thFlag, isRtl: false},
    {code: 'tr', name: 'Türkçe', flag: trFlag, isRtl: false},
    {code: 'uk', name: 'Українська', flag: ukFlag, isRtl: false},
    {code: 'vi', name: 'Tiếng Việt', flag: viFlag, isRtl: false},
    {code: 'zh-CN', name: '中文（中国）', flag: zhcnFlag, isRtl: false},
];
export const defaultLanguage = 'en';
/** END: LANGUAGES MAPPINGS */

export default i18n;
